import { compact } from '@lglp/utils';
import moment from 'moment';

import { DocumentType } from '../../types/document';
import { and, attr, period } from '../algolia/algolia-filters-builder';

export const searchHubNewsroom = ({
  hitsPerPage = 10,
  thematic = [],
  dateRange: [startDate, endDate] = [],
}: SearchHubNewsroomProps): SearchHubReturnProps => {
  return compact<SearchHubReturnProps>({
    hitsPerPage,
    facets: ['filters.thematic'],
    facetFilters: {
      thematic,
    },
    filters: and([
      attr('type', DocumentType.PRESS_RELEASE),
      attr('onNewsroom', 'true'),
      period(
        'createdAt',
        startDate || moment('19700101', 'YYYYMMDD').valueOf(),
        endDate || moment.now()
      ),
    ]),
  });
};

type SearchHubNewsroomProps = {
  hitsPerPage: number;
  thematic: string[];
  dateRange: number[];
};

type SearchHubReturnProps = {
  hitsPerPage: number;
  facets: string[];
  facetFilters: Record<string, any>;
  filters: string;
};
